/**
 * OffCanvas.js
 * Provides right and left sidebar functionality
 *
 * @class   OffCanvas
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({

	displayName: 'OffCanvas',

	propTypes: {
		leftSidebar: React.PropTypes.element,
		leftWidth: React.PropTypes.string,
		rightSidebar: React.PropTypes.element,
		rightWidth: React.PropTypes.string,
		rightPartialWidth: React.PropTypes.string,
		leftOpen: React.PropTypes.bool,
		rightOpen: React.PropTypes.bool,
		type: React.PropTypes.oneOf(['push', 'squeeze', 'overlay']),
		partial: React.PropTypes.bool,
	},

	defaultProps() {
		return {
			leftSidebar: '',
			rightSidebar: '',
			leftOpen: false,
			rightOpen: false,
			type: 'push',
			partial: true
		};
	},

	getInitialState() {
		return {
			open_left: this.props.leftOpen,
			open_right: this.props.rightOpen,
			expanded: false
		};
	},

	render() {

		let {leftWidth, rightWidth, rightPartialWidth, partial } = this.props;

		var offCanvas = ClassNames({
			'lui-oc-outer-wrap': true,
		});

		let sidebarStyles = {
			width: this.state.open_left ? leftWidth : 0
		};

		let mainStyles = {
			paddingLeft: this.state.open_left ? leftWidth : 0,
		};

		let auxbarStyles = {
			width: !this.state.open_right ? 0 : 
				!partial ? rightWidth : 
				this.state.expanded ? rightWidth : 
				rightPartialWidth

		};

		return (
			<div className={offCanvas}>
				<div style={sidebarStyles} className="lui-oc-sidebar">
					{this.props.leftSidebar}
				</div>
				<div style={mainStyles} className="lui-oc-main">
					{this.props.children}
				</div>
				<div style={auxbarStyles} className="lui-oc-auxbar">
					{this.props.rightSidebar}
				</div>
			</div>
		);

	},

	toggleLeft() {
		this.setState({ open_left: !this.state.open_left });
	},

	toggleRight() {

		if(this.state.open_right) {
			this.setState({
				open_right: false,
				expanded: false
			});
		} else {
			this.setState({
				open_right: true,
			});
		}
	},

	toggleExpandRight() {
		if (this.state.open_right) {
			this.setState({
				expanded: !this.state.expanded
			});
		} else {
			this.setState({
				open_right: true,
				expanded: true
			});
		}
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/off-canvas/OffCanvas.js
 **/